<template>
  <div class="wap_index3 main">
    <div class="box_center wap_index3-center">
      <div class="wap_index3-title">
        <div>商务合作</div>
      </div>
      <div class="wap_game_single_nav_x">
        <div class="wap_game_single_nav_ul_x">
          <div @click="wapgameSingle(index)" v-for="(item, index) in list" :key="index"
            :class="wapgameSingindex == index ? 'nav_ul_activate' : ''">
            {{ item.title }}
          </div>
          <div class="wap_game_single_wire_x"></div>
        </div>
      </div>
      <div class="new_wap_index3-ul">
        <template v-if="wapgameSingindex == 0">
          <div class="wapgameSingindex_0">
            <div class="li-card">
              <div class="li-card-name">QQ邮箱</div>
              <div class="li-card-flex">
                <div class="business1 li-card-icon"></div>
                <div>{{businessEmail}}</div>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="wapgameSingindex == 1">
          <div class="wapgameSingindex_0" v-for="(item, index) in listCard" :key="index">
            <div class="li-card" v-for="(row, rowindex) in item.arr" :key="rowindex">
              <div class="li-card-name">{{ row.name }}</div>
              <div class="li-card-flex">
                <div class="business1 li-card-icon"></div>
                <div>{{ row.qq }}</div>
              </div>
              <div class="li-card-flex jg">
                <div class="business2 li-card-icon"></div>
                <div>{{ row.phone }}</div>
              </div>
              <div class="li-card-flex">
                <div class="business3 li-card-icon"></div>
                <div>{{ row.mailbox }}</div>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="wapgameSingindex == 2">
          <div class="wapgameSingindex_2">
            <div class="li-card-qrcode">
              <img :src="qrcode" />
            </div>
            <div class="name2">长按保存 扫码关注</div>
          </div>
        </template>
      </div>
    </div>
    <div v-if="viewportHeight" class="wap_index3_orientation"></div>
  </div>
</template>

<script>
import { businessEmail, businessList } from "@/utils/commonData";

export default {
  data() {
    return {
      businessEmail:businessEmail,
      qrcode: require("../../assets/images/gzh.jpg"),
      viewportHeight: true,
      list: [
        { title: "商务合作" },
        { title: "千年引擎合作" },
        { title: "微信公众号" },
      ],
      listCard: [
        {
          arr: businessList.slice(0, 3),
        },
        {
           arr: businessList.slice(3, 6),
        },
      ],
      wapgameSingindex: 0,
    };
  },
  created() { },
  mounted() { },
  methods: {
    wapgameSingle(index) {
      let special = document.querySelector(".wap_game_single_wire_x");
      let navWidth = document.querySelector(
        ".wap_game_single_wire_x"
      ).clientWidth;
      let liWidth = document.querySelector(".wap_game_single_nav_ul_x")
        .children[index].clientWidth;
      let left =
        document.querySelector(".wap_game_single_nav_ul_x").children[index]
          .offsetLeft -
        (navWidth - liWidth) / 2;
      special.style.transform = `translateX(${left}px)`;
      this.wapgameSingindex = index;
    },
  },
};
</script>

<style scoped lang="scss">
.wap_game_single_nav_x::-webkit-scrollbar {
  background-color: transparent;
}

.wap_game_single_nav_x {
  width: 100%;
  overflow-x: auto;
  position: relative;

  .wap_game_single_nav_ul_x {
    display: flex;
    width: 120%;
    padding-bottom: 0.266667rem
      /* 10/37.5 */
    ;
    border-bottom: 0.053333rem
      /* 2/37.5 */
      solid #707070;
    position: relative;

    >div {
      flex-shrink: 0;
      color: #ffffff;
      margin-right: 0.773333rem
        /* 29/37.5 */
      ;
      font-size: 0.373333rem
        /* 14/37.5 */
      ;
    }

    .nav_ul_activate {
      color: #ff0e0e;
    }
  }

  .wap_game_single_wire_x {
    position: absolute;
    left: 0;
    bottom: -0.026667rem
      /* 1/37.5 */
    ;
    width: 1.813333rem
      /* 68/37.5 */
    ;
    height: 0.053333rem
      /* 2/37.5 */
    ;
    background: #ff0e0e;
    transform: translateX(0);
    transition: transform 500ms cubic-bezier(0.48, 0.33, 0.24, 0.95) 0ms;
  }
}

.new_wap_index3-ul::-webkit-scrollbar {
  background-color: transparent;
}

.new_wap_index3-ul {
  margin-top: 0.266667rem
    /* 10/37.5 */
  ;
  width: 100%;
  overflow-x: auto;

  .wapgameSingindex_0 {
    display: flex;
    align-items: center;
    margin-bottom: 1.6rem
      /* 60/37.5 */
    ;

    .li-card {
      background: #fff;
      box-sizing: border-box;
      padding: 0.266667rem
        /* 10/37.5 */
        0.266667rem
        /* 10/37.5 */
      ;
      border-radius: 0.266667rem
        /* 10/37.5 */
      ;
      flex-shrink: 0;
      width: 6.933333rem
        /* 260/37.5 */
      ;
      margin-right: 0.533333rem
        /* 20/37.5 */
      ;
      font-size: 0.373333rem
        /* 14/37.5 */
      ;
      color: #000;

      .li-card-name {
        font-weight: bold;
        margin-bottom: 0.266667rem
          /* 10/37.5 */
        ;
      }

      .jg {
        padding: 0.533333rem
          /* 20/37.5 */
          0;
      }

      .li-card-flex {
        display: flex;
        align-items: center;

        .li-card-icon {
          flex-shrink: 0;
          width: 0.533333rem
            /* 20/37.5 */
          ;
          height: 0.533333rem
            /* 20/37.5 */
          ;
          background-size: contain;
          margin-right: 0.266667rem
            /* 10/37.5 */
          ;
        }
      }

      .business1 {
        background: url("../../assets/images/web/qq.png") no-repeat center;
      }

      .business2 {
        background: url("../../assets/images/web/phone.png") no-repeat center;
      }

      .business3 {
        background: url("../../assets/images/web/mailbox.png") no-repeat center;
      }
    }
  }

  .wapgameSingindex_2 {
    text-align: center;

    .li-card-qrcode {
      margin: 0 auto;
      height: 6.933333rem
        /* 260/37.5 */
      ;
      width: 6.933333rem
        /* 260/37.5 */
      ;

      // background: url("../../assets//images//gzh.jpg") no-repeat;
      // background-size: cover;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .name2 {
      margin-top: 0.266667rem
        /* 10/37.5 */
      ;
      font-size: 0.373333rem
        /* 14/37.5 */
      ;
      color: #fff;
    }
  }
}

.wap_index3 {
  background: url("../../assets/images/web/two_bg.png") no-repeat center;
  background-size: cover;
  position: relative;
}

.wap_index3-center {
  position: relative;
  z-index: 1;
}

.wap_index3_orientation {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  background: url("../../assets/images/web/orientation.png") no-repeat center;
  background-size: cover;
  width: 8.533333rem
    /* 320/37.5 */
  ;
  height: 6.133333rem
    /* 230/37.5 */
  ;
}

.wap_index3-title {
  padding-top: 1.466667rem
    /* 55/37.5 */
  ;
  padding-bottom: 0.533333rem
    /* 20/37.5 */
  ;
  text-align: center;
}

.wap_index3-title>div:nth-child(1) {
  font-size: 0.533333rem
    /* 20/37.5 */
  ;
  color: #fff;
  font-weight: bold;
}

.wap_index3-title>div:nth-child(2) {
  font-size: 0.32rem
    /* 12/37.5 */
  ;
  color: #707070;
}

.wap_index3-ul_li {
  padding: 0.48rem
    /* 18/37.5 */
  ;
  min-height: 4.586667rem
    /* 172/37.5 */
  ;
  border-radius: 0.4rem
    /* 15/37.5 */
  ;
  box-sizing: border-box;
  margin-bottom: 0.426667rem
    /* 16/37.5 */
  ;
  border: 1px solid #5c5c5c;
}

.wap_index3-ul_li .wap_index3-ul_li1 {
  display: flex;
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff;
  font-size: 0.373333rem
    /* 14/37.5 */
  ;
  align-items: center;
  padding-bottom: 0.48rem
    /* 18/37.5 */
  ;
}

.wap_index3-ul_li .wap_index3-ul_li1>div:nth-child(1) {
  width: 0.64rem
    /* 24/37.5 */
  ;
  display: flex;
  justify-content: center;
  margin-right: 0.373333rem
    /* 14/37.5 */
  ;
}

.wap_index3-ul_li .wap_index3-ul_li1 .business1 {
  width: 0.533333rem
    /* 20/37.5 */
  ;
  height: 0.533333rem
    /* 20/37.5 */
  ;
  background: url("../../assets/images/web/phone.png") no-repeat center;
  background-size: cover;
}

.wap_index3-ul_li .wap_index3-ul_li1 .business2 {
  width: 0.533333rem
    /* 20/37.5 */
  ;
  height: 0.533333rem
    /* 20/37.5 */
  ;
  background: url("../../assets/images/web/mailbox.png") no-repeat center;
  background-size: contain;
}

.wap_index3-ul_li .wap_index3-ul_li1 .business3 {
  width: 0.533333rem
    /* 20/37.5 */
  ;
  height: 0.533333rem
    /* 20/37.5 */
  ;
  background: url("../../assets/images/web/qq.png") no-repeat center;
  background-size: cover;
}

.wap_index3-ul_li .wap_index3-ul_li1 .business4 {
  width: 0.64rem
    /* 24/37.5 */
  ;
  height: 0.533333rem
    /* 20/37.5 */
  ;
  background: url("../../assets/images/web/wx.png") no-repeat center;
  background-size: cover;
}

@media (max-width: 750px) and (max-height: 667px) {
  .wap_index3_orientation {
    display: none;
  }

  .wap_index3-title {
    padding-top: 1.466667rem
      /* 55/37.5 */
    ;
    padding-bottom: 0.4rem
      /* 15/37.5 */
    ;
  }
}
</style>
